module.exports = {"x0":25,"x1":55,"y1":50,"x2":60,"y2":50,"x3":30}


//////////////////
// WEBPACK FOOTER
// ./scripts/config/flickiyArrowShape.json
// module id = 15
// module chunks = 0